import React, { useContext } from "react";
import styles from "./styles.module.scss";
import { formatMoney } from "../../utils/helpers";
import AppContext from "../../hooks/appContext";
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import NextImage from 'next/image';

const ProductCard = (props) => {

  const clickAction = (product) => {
    props.action(product)
  }

  const clickModal = (product) => {
    props.openDetail(product);
  }

    const {
        currentCurrency,
        getCurrentCurrencySign,
    } = useContext(AppContext);

  const mobileAddToCartClasses = `${styles['btn-add-to-cart']} ${styles['mobile-btn']}`

    const getProductPricing = () => {
        if (!props.product.variants.length > 0) {
            return `${getCurrentCurrencySign()}${formatMoney(props.price / 100)}`;
        }
        const amountsForCurrency = props.product.variants.flatMap(item => item.amounts.filter(amount => amount.currency_id === currentCurrency));

        const highestAmount = Math.max(...amountsForCurrency.map(amount => amount.amount));
        const lowestAmount = Math.min(...amountsForCurrency.map(amount => amount.amount));

        return `${getCurrentCurrencySign()}${formatMoney(lowestAmount / 100)} - ${getCurrentCurrencySign()}${formatMoney(highestAmount / 100)}`;
    }

    return (
        <>
            <div className={styles['product-card']}>
                <div className={styles['card-image']} onClick={() => clickModal(props.product)}>
                    <NextImage alt="" width={600} height={600} src={props.image} className={styles['product-image']}/>
                </div>

                <div className={styles['product-info']}>
                    <div className={styles['product-details']}>
                        <div className={styles['detail-text']}>
                            <div className={styles['product-name']}>{props.name}</div>
                            <div className={styles['details-bottom']}>
                                <div className={styles.prices}>
                                    {
                                        parseInt(props.old_price) > parseInt(props.price) ?
                                            <div className={styles['old-price']}>
                                                {getCurrentCurrencySign()}{formatMoney(props.old_price / 100)}
                                            </div>
                                            : null
                                    }
                                    <div className={styles['product-price']}>
                                        {getProductPricing()}
                                    </div>
                                </div>
                                
                                <button className={styles['btn-add-to-cart']} onClick={() => clickModal(props.product)}><ShoppingCartOutlinedIcon /></button>
                            </div>
                        </div>
                        {/* <button className={mobileAddToCartClasses} onClick={() => clickAction(props.product)}><ShoppingCartOutlinedIcon /></button> */}
                        <button className={mobileAddToCartClasses} onClick={() => clickModal(props.product)}><ShoppingCartOutlinedIcon /></button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductCard